export default __webpack_public_path__ + "static/media/conteudo_extra_03.6ddd14a5.jpg";